import Mustache from "mustache";
import { COMPANY_LOGO_EMAIL_URL } from "../../config/appSiteLinks";
import en from "./weekly/weekly_notification_en.mustache";
import footer from "./weekly/_common_footer.mustache";
import styles from "./weekly/_common_styles.mustache";
import images from "./weekly/_weekly_image_puzzles.mustache";
import sections from "./weekly/_weekly_puzzle_sections.mustache";

const PARTIALS = {
    "mail/home/weekly/_common_styles": styles,
    "mail/home/weekly/_weekly_puzzle_sections": sections,
    "mail/home/weekly/_weekly_image_puzzles": images,
    "mail/home/weekly/_common_footer": footer,
};

/** Other languages stay in the list for later. Only English has a template now. */
export const WEEKLY_LOCALES = [
    { value: "en", label: "English", enabled: true },
    { value: "fr", label: "French", enabled: false },
    { value: "es", label: "Spanish", enabled: false },
    { value: "de", label: "German", enabled: false },
    { value: "it", label: "Italian", enabled: false },
    { value: "pt", label: "Portuguese", enabled: false },
    { value: "ru", label: "Russian", enabled: false },
    { value: "zh", label: "Chinese", enabled: false },
    { value: "ja", label: "Japanese", enabled: false },
    { value: "ko", label: "Korean", enabled: false },
];

export const DEFAULT_WEEKLY_SUBJECT = "{{subjectPrefix}}{{puzzleSubject}}";

const DESIGN_VIEW = {
    puzzleWord: "puzzles",
    hostUrl: "https://www.puzzleinteract.com",
    hasJigsaw: true,
    jigsawTypeLabel: "Jigsaw",
    jigsawTagline: "Jigsaw Spotlight • Medium (150 Pieces)",
    jigsawTitle: "Caramel Apple Tart",
    jigsawImageUrl:
        "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/story-icon-400/standalone/95a4b7af-c513-403f-a7e0-7bb2d89cb23a/0e8bdfd8-f60f-4be7-8b61-1e267727f0ba.png",
    jigsawPlayUrl: "https://www.puzzleinteract.com",
    hasWordWheel: true,
    wordWheelTypeLabel: "Word Wheel",
    wordWheelCaption: "Can you help us solve today’s open clue?<br/>Unscramble the wheel letters and drop your guess in the comments!",
    wordWheelSlots: [
        { letter: "C" },
        { letter: "" },
        { letter: "" },
        { letter: "S" },
    ],
    wordWheelLetterCount: 4,
    wordWheelLinkUrl: "https://www.puzzleinteract.com/puzzle/play-word-wheel",
    playNowLabel: "Play now",
    playShortLabel: "Play",
    hasMorePuzzles: true,
    morePuzzlesTitle: "More puzzles",
    morePuzzles: [
        { typeLabel: "Crossword", title: "Harbor at First Light", playUrl: "https://www.puzzleinteract.com" },
        { typeLabel: "Hidden Message", title: "Letters in the Orchard", playUrl: "https://www.puzzleinteract.com" },
        { typeLabel: "Word Search", title: "Market Day in Provence", playUrl: "https://www.puzzleinteract.com" },
    ],
    /** Prefer this in sends: omitted when no puzzles were published this week. */
    morePuzzlesSection: {
        title: "More puzzles",
        rows: [
            { typeLabel: "Crossword", title: "Harbor at First Light", playUrl: "https://www.puzzleinteract.com" },
            { typeLabel: "Hidden Message", title: "Letters in the Orchard", playUrl: "https://www.puzzleinteract.com" },
            { typeLabel: "Word Search", title: "Market Day in Provence", playUrl: "https://www.puzzleinteract.com" },
        ],
    },
    logoUrl: COMPANY_LOGO_EMAIL_URL,
    companyName: "Puzzle Interact",
    supportLabel: "Support",
    emailSupport: "support@puzzleinteract.com",
    unsubscribeLabel: "Unsubscribe",
    unsubscribeUrl: "https://www.puzzleinteract.com",
};

function inlinePartials(source, depth = 0) {
    if (depth > 8 || typeof source !== "string") {
        return "";
    }
    return source.replace(/\{\{>\s*([^}\s]+)\s*\}\}/g, (_, name) => {
        const partial = PARTIALS[name];
        if (typeof partial !== "string") {
            return "";
        }
        return inlinePartials(partial, depth + 1);
    });
}

export function defaultWeeklyHtml() {
    return inlinePartials(en);
}

/** Renders the weekly template as the email design, with sample puzzles filled in. */
export function renderWeeklyDesign(source) {
    const inlined = inlinePartials(typeof source === "string" ? source : "");
    if (!inlined.trim()) {
        return "";
    }
    return Mustache.render(inlined, DESIGN_VIEW);
}
